import moment from 'moment/moment';

export const formatCurrency = (number: number): string =>
  new Intl.NumberFormat('en', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(Number(number));

export const formatCurrencyWithSign = (number: number): string => {
  if (number > 0) {
    return `+R${formatCurrency(number)}`;
  }

  return `-R${formatCurrency(Math.abs(number))}`;
};

export const formatDate = (date: Date): string => {
  return moment(date).format('DD.MM.YYYY');
};

export const ensureFirstPlus = (phoneNumber: string): string => {
  return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
};
